import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

const SUPPORTED_LOCALES = ["de"] as const;

export const Route = createFileRoute("/__main/$locale")({
  beforeLoad: ({ params }) => {
    if (!SUPPORTED_LOCALES.includes(params.locale as (typeof SUPPORTED_LOCALES)[number])) {
      throw redirect({ to: "/de" as any });
    }
  },
  component: () => <Outlet />,
});
